module.exports = __webpack_public_path__ + "static/img/kv02.69fa61b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/nav-2/kv02.jpg
// module id = /ooZ
// module chunks = 0